// extracted by mini-css-extract-plugin
module.exports = {"planSwitcherContainer":"styles_planSwitcherContainer__Rbsi0","slider":"styles_slider__zWcUf","yearlyContainer":"styles_yearlyContainer__U2Lm5","discount":"styles_discount__24Ydo"};